<h1 mat-dialog-title>Custom Appointment</h1>
<div mat-dialog-content>
  <p>Provide information for this custom appointment.</p>
  <form #appointmentForm="ngForm" (ngSubmit)="updateAppointment(appointmentForm)">
    <div class="modal-body">
      <div class="form-group row">
        <label for="appointment_Description" class="col-sm-4 col-form-label">Description</label>
        <div class="col-sm-8">
          <textarea class="form-control" name="appointment_Description"
                    [disabled]="data.readOnly"
                    rows="3"
                    [(ngModel)]="data.appointment.appointment_Description" #appointment_Description="ngModel"></textarea>
        </div>
      </div>

      <div class="form-group row">
        <label for="workOrder_Start" class="col-sm-4 col-form-label">
          <span class="warning">* </span>Start Date
        </label>
        <div class="col-sm-4 form-inline">
          <input name="workOrder_Start" class="form-control narrow-input"
                 matInput
                 placeholder="mm/dd/yyyy"
                 required
                 [disabled]="data.readOnly"
                 [matDatepicker]="startPicker"
                 [(ngModel)]="data.appointment.appointment_Start" #appointment_Start="ngModel" />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </div>
        <div class="col-sm-4">
          <select name="startTime" class="form-control select-bidit"
                  required
                  [disabled]="data.readOnly"
                  [(ngModel)]="data.startTime" #startTime="ngModel">
            <option value="">-</option>
            <option *ngFor="let time of data.times" [ngValue]="time">{{time}}</option>
          </select>
        </div>
        <div [hidden]="!appointmentForm.submitted || (appointment_Start.valid && startTime.valid)"
             class="alert alert-danger col-sm-12">
          Enter a valid start date and time
        </div>
      </div>
      <div class="form-group row">
        <label for="appointment_Stop" class="col-sm-4 col-form-label">
          <span class="warning">* </span>End Date
        </label>
        <div class="col-sm-4 form-inline">
          <input name="appointment_Stop" class="form-control narrow-input"
                 matInput
                 placeholder="mm/dd/yyyy"
                 required
                 [disabled]="data.readOnly"
                 [matDatepicker]="stopPicker"
                 [(ngModel)]="data.appointment.appointment_Stop" #appointment_Stop="ngModel" />
          <mat-datepicker-toggle matSuffix [for]="stopPicker"></mat-datepicker-toggle>
          <mat-datepicker #stopPicker></mat-datepicker>
        </div>
        <div class="col-sm-4">
          <select name="stopTime" class="form-control select-bidit"
                  required
                  [disabled]="data.readOnly"
                  [(ngModel)]="data.stopTime" #stopTime="ngModel">
            <option value="">-</option>
            <option *ngFor="let time of data.times" [ngValue]="time">{{time}}</option>
          </select>
        </div>
        <div [hidden]="!appointmentForm.submitted || (appointment_Stop.valid && stopTime.valid)"
             class="alert alert-danger col-sm-12">
          Enter a valid end date and time
        </div>
      </div>

      <div class="form-group row">
        <label for="appointment_Instructions" class="col-sm-4 col-form-label">Instructions</label>
        <div class="col-sm-8">
          <textarea class="form-control" name="appointment_Instructions"
                    [disabled]="data.readOnly"
                    rows="3"
                    [(ngModel)]="data.appointment.appointment_Instructions" #appointment_Instructions="ngModel"></textarea>
        </div>
      </div>
      <div class="form-group row">
        <label for="useSameTimesMultiDay" class="col-sm-4 col-form-label" i18n>Use Same Times Multi-Day</label>
        <div class="col-sm-8">
          <mat-radio-group area-label="Use Same Times Multi-Day" name="useSameTimesMultiDay"
                           [(ngModel)]="data.appointment.useSameTimesMultiDay">
            <mat-radio-button [value]="false" class="pr-2" i18n>No</mat-radio-button>
            <mat-radio-button [value]="true" i18n>Yes</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4" for="crewColor">Appointment Color</label>
        <input type="color" id="appointment_Color" name="appointment_Color"
               class="form-control col-sm-2" [(ngModel)]="data.appointment.appointment_Color">
      </div>
      <div [hidden]="timeAlert == null"
           class="alert alert-danger">
        {{timeAlert}}
      </div>
    </div>
    <div [hidden]="!appointmentForm.submitted || appointmentForm.valid"
         class="alert alert-danger">
      Validation issues encountered.  Please review your entered information.
    </div>
    <div *ngIf="!isRequesting" class="row">
      <div class="col-sm-9">
        <button type="submit" mat-button class="btn btn-bidit-action mr-1">Submit</button>
        <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel">Cancel</button>
      </div>
      <div class="col-sm-3 text-right">
        <button *ngIf="data.appointment.appointment_ID" type="button" mat-button (click)="deleteAppointment()"
                class="mr-2 btn btn-bidit-warn">
          Delete
        </button>
      </div>
    </div>
    <div *ngIf="isRequesting" class="row">
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </form>
</div>
